const config = {
  BASE_URL: "https://funlab-backend-ot1x.onrender.com",
};

export default config;
